import { render } from "./FileUpload.vue?vue&type=template&id=5c0a507c&ts=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"

import "./FileUpload.vue?vue&type=style&index=0&id=5c0a507c&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__